<template>
    <ul class="unordered-list">
        <slot />
    </ul>
</template>
<script>
export default {
    name: 'UnOrderedList'
}
</script>